<template>
  <div class="actions">
    <div class="actions__boolean">
      <el-radio-group v-model="enabledSync" class="actions__boolean__input">
        <el-radio-button :label="false">{{ labelsObject.falseLabel }}</el-radio-button>
        <el-radio-button :label="true">{{ labelsObject.trueLabel }}</el-radio-button>
      </el-radio-group>
      <p class="actions__boolean__text" v-html="labelsObject.textLabel">
      </p>
    </div>
    <div class="actions__input" v-if="enabledSync">
      <el-button
        class="actions__input__button"
        :icon="minusIcon"
        size="small"
        @click="decrease"
        :disabled="modelValue <= min">
      </el-button>
      <span class="actions__input__value">{{ modelValue || 0 }}</span>
      <el-button
        class="actions__input__button"
        :class="{active: active}"
        :icon="plusIcon"
        size="small"
        @click="increase"
        :disabled="modelValue >= max">
      </el-button>
    </div>
  </div>
</template>

<script>
import InputNumber from '@nextories/vue-core-components/src/components/atoms/input/NxtCoreInputNumber.vue';
import { Plus, Minus } from '@element-plus/icons-vue';

export default {
  emits: (InputNumber.emits || []).concat(['update:enabled']),
  name: 'serviceInputAction',
  extends: InputNumber,
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    enabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    enabledSync: {
      get() {
        return this.enabled;
      },
      set(enabled) {
        this.$emit('update:enabled', enabled);
      },
    },
    labelsObject() {
      return {
        trueLabel: this.$t('base.yes'),
        falseLabel: this.$t('base.no'),
        textLabel: this.label,
      };
    },
    plusIcon() {
      return Plus;
    },
    minusIcon() {
      return Minus;
    },
  },
};
</script>

<style scoped lang="scss">
.actions {
  padding: 20px;
  background-color: #E5FCF5;
  border-radius: 4px;
  &__boolean {
    display: flex;
    flex-direction: column;
    @include breakpoint(desktop) {
      flex-direction: row;
    }
    &__input {
      margin: auto 20px auto 0;
 
      :deep(.el-radio-button__inner) {
        padding: 12px 20px;
      }
    }
    &__text {
      flex: 1;
      margin: 0;
      font-size: 20px;
      display: flex;
      align-items: center;
    }
  }
  &__input {
    margin-top: 20px;
    padding: 10px;
    text-align: center;
    background-color: #CDF9EC;
    border-radius: 4px;
    display: block;
    &__value {
      padding: 10px 20px;
      @include breakpoint(desktop) {
        padding: 0 40px;
      }
    }
    &__button {
      padding: 10px 35px;
    }
  }
}
</style>
